import React from 'react';
import PropTypes from 'prop-types';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';

const TRANSFORM_ORIGINS = {
  'bottom-end'  : 'right top',
  'bottom-start': 'left top',
  'bottom'      : 'center top',
  'left-end'    : 'right top',
  'left-start'  : 'right top',
  'left'        : 'right top',
  'right-end'   : 'left top',
  'right-start' : 'left top',
  'right'       : 'left top',
  'top-end'     : 'right bottom',
  'top-start'   : 'left bottom',
  'top'         : 'center bottom',
};

export default function GrowPopper({ onClose, children, paperClassName, ...rest }) {
  return (
    <Popper {...rest} transition>
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: TRANSFORM_ORIGINS[placement] }}
        >
          <Paper className={paperClassName}>
            <ClickAwayListener onClickAway={onClose}>
              {children}
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
}

GrowPopper.propTypes = {
  onClose: PropTypes.func,
};

